import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';

export const dividerStyles = css`
  padding: 1.5rem 1rem;
  border-bottom: 1px solid ${COLORS.Grey3};
`;

export const Divider = styled.div<{noMargin?: boolean}>`
  border-top: 1px solid ${COLORS.Grey3};
  width: 100%;

  ${({noMargin}) =>
    !noMargin &&
    css`
      margin: 1.5rem 0;
    `}
`;
